export default __webpack_public_path__ + "static/media/no_image.f05dfb4c.jpg";